import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import render from '@/components/FormGenerator/components/render/render.js';
import { getProvinceListApi, getCityListApi } from '@/api/city';
var ruleTrigger = {
  'el-input': 'blur',
  'el-input-number': 'blur',
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change'
};
function renderFrom(h) {
  var formConfCopy = this.formConfCopy;
  return h("el-row", {
    "attrs": {
      "gutter": formConfCopy.gutter
    }
  }, [h("el-form", _mergeJSXProps([{
    "attrs": {
      "size": formConfCopy.size,
      "label-position": formConfCopy.labelPosition,
      "disabled": formConfCopy.disabled,
      "label-width": "".concat(formConfCopy.labelWidth, "px")
    },
    "ref": formConfCopy.formRef
  }, {
    "props": {
      model: this[formConfCopy.formModel]
    }
  }, {
    "attrs": {
      "rules": this[formConfCopy.formRules]
    }
  }]), [renderFormItem.call(this, h, formConfCopy.fields), formConfCopy.formBtns && formBtns.call(this, h)])]);
}
function formBtns(h) {
  return h("el-col", [h("el-form-item", [h("el-button", {
    "attrs": {
      "type": "primary"
    },
    "directives": [{
      name: "debounce-click",
      value: this.submitForm
    }]
  }, ["\u63D0\u4EA4"])])]);
}
function renderFormItem(h, elementList) {
  var _this = this;
  return elementList.map(function (scheme) {
    var config = scheme.__config__;
    var layout = layouts[config.layout];
    if (layout) {
      return layout.call(_this, h, scheme);
    }
    throw new Error("\u6CA1\u6709\u4E0E".concat(config.layout, "\u5339\u914D\u7684layout"));
  });
}
function renderChildren(h, scheme) {
  var config = scheme.__config__;
  if (!Array.isArray(config.children)) return null;
  return renderFormItem.call(this, h, config.children);
}
function setValue(event, config, scheme) {
  this.$set(config, 'defaultValue', event);
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event);
}
function buildListeners(scheme) {
  var _this2 = this;
  var config = scheme.__config__;
  var methods = this.formConf.__methods__ || {};
  var listeners = {};

  // 给__methods__中的方法绑定this和event
  Object.keys(methods).forEach(function (key) {
    listeners[key] = function (event) {
      return methods[key].call(_this2, event);
    };
  });
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = function (event) {
    return setValue.call(_this2, event, config, scheme);
  };
  return listeners;
}

// 省市下拉框渲染动态数据
function buildOptions(scheme) {
  var vModel = scheme.__vModel__;
  var options = [];
  if (vModel === 'provId') {
    this.provinceList.forEach(function (item) {
      options.push({
        label: item.regionName,
        value: item.regionId
      });
    });
    scheme.__slot__ = scheme.__slot__ || {};
    scheme.__slot__.options = options;
  } else if (vModel === 'areaId') {
    this.cityList.forEach(function (item) {
      options.push({
        label: item.regionName,
        value: item.regionId
      });
    });
    scheme.__slot__ = scheme.__slot__ || {};
    scheme.__slot__.options = options;
  }
}
var layouts = {
  colFormItem: function colFormItem(h, scheme) {
    var config = scheme.__config__;
    var listeners = buildListeners.call(this, scheme);
    var labelWidth = config.labelWidth ? "".concat(config.labelWidth, "px") : null;
    if (config.showLabel === false) labelWidth = '0';

    // 省市下拉框渲染动态数据
    buildOptions.call(this, scheme);
    if (config.tips && !config.tipsIsLink) {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "attrs": {
          "label-width": labelWidth,
          "prop": scheme.__vModel__,
          "label": config.showLabel ? config.label : ''
        }
      }, [h(render, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      }), h("div", [h("span", {
        "class": "tips-info"
      }, [config.tipsDesc])])])]);
    } else if (config.tips && config.tipsIsLink) {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "attrs": {
          "label-width": labelWidth,
          "prop": scheme.__vModel__,
          "label": config.showLabel ? config.label : ''
        }
      }, [h(render, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      }), h("div", [h("el-link", {
        "class": "tips-info",
        "attrs": {
          "type": "info",
          "href": config.tipsLink,
          "target": "_blank"
        }
      }, [config.tipsDesc])])])]);
    } else {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "attrs": {
          "label-width": labelWidth,
          "prop": scheme.__vModel__,
          "label": config.showLabel ? config.label : ''
        }
      }, [h(render, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      })])]);
    }
  },
  rowFormItem: function rowFormItem(h, scheme) {
    var child = renderChildren.apply(this, arguments);
    if (scheme.type === 'flex') {
      child = h("el-row", {
        "attrs": {
          "type": scheme.type,
          "justify": scheme.justify,
          "align": scheme.align
        }
      }, [child]);
    }
    return h("el-col", {
      "attrs": {
        "span": scheme.span
      }
    }, [h("el-row", {
      "attrs": {
        "gutter": scheme.gutter
      }
    }, [child])]);
  }
};
export default {
  components: {
    render: render
  },
  props: {
    formConf: {
      type: Object,
      required: true
    },
    formEditData: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    // 检查是否有省市字段
    var hasProvinceField = this.formConf.fields.some(function (f) {
      return f.__vModel__ === 'provId';
    });
    var hasCityField = this.formConf.fields.some(function (f) {
      return f.__vModel__ === 'areaId';
    });
    var data = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      formConfCopy: JSON.parse(JSON.stringify(this.formConf))
    }, this.formConf.formModel, {}), this.formConf.formRules, {}), "provinceList", []), "cityList", []), "dataLoaded", !hasProvinceField), "currentProvId", null), "hasProvinceField", hasProvinceField), "hasCityField", hasCityField);
    this.initFormData(data.formConfCopy.fields, data[this.formConf.formModel]);
    this.buildRules(data.formConfCopy.fields, data[this.formConf.formRules]);
    return data;
  },
  created: function created() {
    console.log('Parser created, hasProvinceField:', this.hasProvinceField);

    // 如果有省市字段，加载数据后再显示
    if (this.hasProvinceField) {
      this.loadProvinceAndCityData();
    } else {
      this.dataLoaded = true;
    }
  },
  watch: {
    cityList: {
      handler: function handler(newVal) {
        console.log('cityList 变化:', newVal.length);
        if (newVal.length > 0) {
          this.$forceUpdate();
        }
      }
    },
    'provId': function provId(newVal) {
      var _this3 = this;
      console.log('provId 变化:', newVal);
      if (newVal) {
        getCityListApi(newVal).then(function (res) {
          if (res.data) {
            _this3.cityList = res.data;
            console.log('城市数据加载完成:', res.data.length, '条');
          }
        });
      } else {
        this.cityList = [];
      }
    }
  },
  methods: {
    // 加载省份和城市数据
    loadProvinceAndCityData: function () {
      var _loadProvinceAndCityData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var provRes, provinceData, provField, _provField, cityRes, cityData, cityField, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              console.log('开始加载省市数据...');
              _context.p = 1;
              _context.n = 2;
              return getProvinceListApi();
            case 2:
              provRes = _context.v;
              provinceData = Array.isArray(provRes) ? provRes : provRes.data || [];
              if (provinceData.length > 0) {
                this.provinceList = provinceData;
                console.log('省份数据加载完成:', provinceData.length, '条');

                // 找到省份字段并设置选项 - 保持 value 为数字类型
                provField = this.formConf.fields.find(function (f) {
                  return f.__vModel__ === 'provId';
                });
                if (provField) {
                  provField.__slot__ = provField.__slot__ || {};
                  provField.__slot__.options = provinceData.map(function (item) {
                    return {
                      label: item.regionName,
                      value: Number(item.regionId) // 确保是数字类型
                    };
                  });
                  console.log('省份选项设置完成:', provField.__slot__.options.length);
                  console.log('省份选项第一个:', JSON.stringify(provField.__slot__.options[0]));
                }
              }

              // 2. 如果是编辑模式，处理省市字段的反显
              if (!(this.isEdit && this.formEditData)) {
                _context.n = 4;
                break;
              }
              console.log('编辑模式 - 处理省市字段反显');

              // 先处理省字段反显
              _provField = this.formConf.fields.find(function (f) {
                return f.__vModel__ === 'provId';
              });
              if (!(_provField && this.formEditData.provId)) {
                _context.n = 4;
                break;
              }
              _provField.__config__.defaultValue = Number(this.formEditData.provId); // 转为数字
              console.log('省份 defaultValue 设置为:', _provField.__config__.defaultValue, '类型:', _typeof(_provField.__config__.defaultValue));

              // 加载对应的城市列表
              _context.n = 3;
              return getCityListApi(this.formEditData.provId);
            case 3:
              cityRes = _context.v;
              cityData = Array.isArray(cityRes) ? cityRes : cityRes.data || [];
              if (cityData.length > 0) {
                this.cityList = cityData;
                console.log('城市数据加载完成:', cityData.length, '条');

                // 找到城市字段并设置选项
                cityField = this.formConf.fields.find(function (f) {
                  return f.__vModel__ === 'areaId';
                });
                if (cityField) {
                  cityField.__slot__ = cityField.__slot__ || {};
                  cityField.__slot__.options = cityData.map(function (item) {
                    return {
                      label: item.regionName,
                      value: Number(item.regionId) // 确保是数字类型
                    };
                  });
                  console.log('城市选项设置完成:', cityField.__slot__.options.length);

                  // 处理城市字段反显
                  if (this.formEditData.areaId) {
                    cityField.__config__.defaultValue = Number(this.formEditData.areaId); // 转为数字
                    console.log('城市 defaultValue 设置为:', cityField.__config__.defaultValue, '类型:', _typeof(cityField.__config__.defaultValue));
                  }
                }
              }
            case 4:
              // 3. 如果是编辑模式，处理其他字段的反显
              if (this.isEdit) {
                this.formConf.fields.forEach(function (conf) {
                  var hasValueForEdit = _this4.formEditData[conf.__vModel__];
                  if (hasValueForEdit && conf.__vModel__ !== 'provId' && conf.__vModel__ !== 'areaId') {
                    conf.__config__.defaultValue = hasValueForEdit;
                  }
                  if ((conf.__config__.tag === 'el-select' || conf.__config__.tag === 'el-radio-group') && conf.__vModel__ !== 'provId' && conf.__vModel__ !== 'areaId') {
                    var perValue = conf.__slot__.options.filter(function (option) {
                      return option.value == _this4.formEditData[conf.__vModel__];
                    });
                    if (perValue.length > 0) {
                      conf.__config__.defaultValue = perValue[0].value;
                    }
                  }
                });
              }

              // 4. 重新深拷贝（此时 options 和 defaultValue 都已设置好）
              this.formConfCopy = JSON.parse(JSON.stringify(this.formConf));
              console.log('深拷贝完成');

              // 5. 初始化表单数据，但跳过省市字段
              this.formConfCopy.fields.forEach(function (cur) {
                var config = cur.__config__;
                // 跳过省市字段，后面手动处理
                if (cur.__vModel__ === 'provId' || cur.__vModel__ === 'areaId') {
                  return;
                }
                if (cur.__vModel__) {
                  _this4[_this4.formConf.formModel][cur.__vModel__] = config.defaultValue;
                }
                if (config.children) {
                  _this4.initFormData(config.children, _this4[_this4.formConf.formModel]);
                }
              });

              // 6. 手动设置省市字段的值（确保数字类型，并注册到 formModel 中）
              if (this.isEdit && this.formEditData) {
                // 先注册空值，确保字段存在
                this[this.formConf.formModel].provId = null;
                this[this.formConf.formModel].areaId = null;
                if (this.formEditData.provId) {
                  this[this.formConf.formModel].provId = Number(this.formEditData.provId);
                  console.log('provId 值设置:', this[this.formConf.formModel].provId, '类型:', _typeof(this[this.formConf.formModel].provId));
                }
                if (this.formEditData.areaId) {
                  this[this.formConf.formModel].areaId = Number(this.formEditData.areaId);
                  console.log('areaId 值设置:', this[this.formConf.formModel].areaId, '类型:', _typeof(this[this.formConf.formModel].areaId));
                }
              } else {
                // 新增模式也要注册空值
                this[this.formConf.formModel].provId = null;
                this[this.formConf.formModel].areaId = null;
              }

              // 打印最终 formModel 内容用于调试
              console.log('最终 formModel:', JSON.stringify(this[this.formConf.formModel]));

              // 7. 数据加载完成
              this.dataLoaded = true;
              console.log('省市数据加载完成，准备渲染表单');
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('加载省市数据失败:', _t);
              console.error('错误堆栈:', _t.stack);
              this.dataLoaded = true;
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 5]]);
      }));
      function loadProvinceAndCityData() {
        return _loadProvinceAndCityData.apply(this, arguments);
      }
      return loadProvinceAndCityData;
    }(),
    loadProvinceList: function loadProvinceList() {
      return getProvinceListApi().then(function (res) {
        if (res.data) {
          console.log('省份数据:', res.data);
          return res.data;
        }
        return [];
      });
    },
    loadCityList: function loadCityList(parentId) {
      return getCityListApi(parentId).then(function (res) {
        if (res.data) {
          console.log('城市数据:', res.data);
          return res.data;
        }
        return [];
      });
    },
    initFormData: function initFormData(componentList, formData) {
      var _this5 = this;
      componentList.forEach(function (cur) {
        var config = cur.__config__;
        if (cur.__vModel__) formData[cur.__vModel__] = config.defaultValue;
        if (config.children) _this5.initFormData(config.children, formData);
      });
    },
    buildRules: function buildRules(componentList, rules) {
      var _this6 = this;
      componentList.forEach(function (cur) {
        var config = cur.__config__;
        if (Array.isArray(config.regList)) {
          if (config.required) {
            var required = {
              required: config.required,
              message: cur.placeholder
            };
            if (Array.isArray(config.defaultValue)) {
              required.type = 'array';
              required.message = "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A".concat(config.label);
            }
            required.message === undefined && (required.message = "".concat(config.label, "\u4E0D\u80FD\u4E3A\u7A7A"));
            config.regList.push(required);
          }
          rules[cur.__vModel__] = config.regList.map(function (item) {
            item.pattern && (item.pattern = eval(item.pattern));
            item.trigger = ruleTrigger && ruleTrigger[config.tag];
            return item;
          });
        }
        if (config.children) _this6.buildRules(config.children, rules);
      });
    },
    resetForm: function resetForm() {
      this.$emit('resetForm', this.formConf);
      this.formConfCopy = JSON.parse(JSON.stringify(this.formConf));
      this.$refs[this.formConf.formRef].resetFields();
    },
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs[this.formConf.formRef].validate(function (valid) {
        if (!valid) return false;
        _this7.$emit('submit', _this7[_this7.formConf.formModel]);
        return true;
      });
    }
  },
  render: function render(h) {
    // 等待数据加载完成才渲染表单
    if (!this.dataLoaded) {
      console.log('等待数据加载...');
      return h("div", {
        "style": "padding: 20px; text-align: center; color: #999;"
      }, ["\u52A0\u8F7D\u4E2D..."]);
    }
    console.log('开始渲染表单');
    return renderFrom.call(this, h);
  }
};